<div
  class="backgroundLogin"
  [ngClass]="{ backgroundEffect: backEffect }"
  [style.background-image]="
    'url(./assets/img/' + customTheme + '/imagesLogin/' + img + ')'
  "
></div>
<div class="container-recover">
  <mat-card class="recover-card">
    <img id="tower-img" class="login-logo" [src]="logoUrl" />
    <div>
      <p class="title text-center">{{ 'k000627' | translate }}</p>
      <!-- Token: Recuperar comntraseña -->
      <p class="content text-left">{{ 'k001837' | translate }}</p>
      <!-- Token: Please, enter your identifier with which you access your Client Area so that we can
        send you a new password. -->
      <form [formGroup]="form" (ngSubmit)="onSendEmail()" class="form-recover">
        <mat-form-field>
          <input
            matInput
            placeholder="{{ 'k000079' | translate }}"
            type="text"
            formControlName="user"
            class="ipt-item"
          />
        </mat-form-field>
        <button
          #btnSend
          color="primary"
          type="submit"
          [disabled]="form.invalid"
          class="buttonPortal btn-send-email"
        >
          <span *ngIf="!faSpinner">{{ 'k000018' | translate }}</span
          ><!-- Token: Enviar -->
          <fa-icon [icon]="faSpinner" [spin]="true" *ngIf="faSpinner"></fa-icon>
        </button>
      </form>
    </div>
    <a class="recover-back" routerLink="/login">{{ 'k001838' | translate }}</a>
    <!-- Token: Back to mainpage -->
  </mat-card>
</div>
